const VISITOR_ID_KEY = "ghibgen_visitor_id";
const TTL_MS = 180 * 24 * 60 * 60 * 1000; // 180 days

interface StoredVisitorId {
  visitorId: string;
  expiresAt: number;
}

function generate(): string {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getOrCreateVisitorId(): string | undefined {
  if (typeof window === "undefined") return undefined;
  try {
    const raw = localStorage.getItem(VISITOR_ID_KEY);
    if (raw) {
      const parsed: StoredVisitorId = JSON.parse(raw);
      if (parsed.expiresAt > Date.now()) return parsed.visitorId;
    }
  } catch {
    // storage unavailable
  }
  const visitorId = generate();
  try {
    localStorage.setItem(
      VISITOR_ID_KEY,
      JSON.stringify({ visitorId, expiresAt: Date.now() + TTL_MS }),
    );
  } catch {
    // ignore
  }
  return visitorId;
}
